import React from "react";
import "./Join.css";

const Join = () => {
  return (
    <section className="flexCenter j-wrapper">
      <div className="paddings innerWidth flexCenter j-container">
        <div className="flexColCenter inner-container">
          <span className="primaryText">
            Join Our Little Lemon Club to Get Exclusive Discounts.
          </span>
          <button className="button">Sign Up</button>
        </div>
      </div>
    </section>
  );
};

export default Join;
